import { render, staticRenderFns } from "./SupplierMatchPage.vue?vue&type=template&id=5a73c4a8&scoped=true&lang=pug&"
import script from "./SupplierMatchPage.vue?vue&type=script&lang=js&"
export * from "./SupplierMatchPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierMatchPage.vue?vue&type=style&index=0&id=5a73c4a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a73c4a8",
  null
  
)

export default component.exports